import { createPromocodeRegistry } from 'entities/promocode';
import { voucherPagePromocodeModel } from '../../model';

const PromocodeRegistry = createPromocodeRegistry(voucherPagePromocodeModel.promocodeRegistryModel);

export const VoucherPagePromocode = () => <PromocodeRegistry />;
